import { AnalyticsBrowser } from '@segment/analytics-next';
import segmentTypes from 'EventTracking/consts/segmentEvents';
import Dispatcher from '../Dispatcher';

const getAPIKey = () => {
  const url = new URL(window.location.href);

  switch (process.env.REACT_APP_STAGE) {
    case 'prod':
      return url.host === 'app.facet.com' ? 'whE0kFa6unIP0IebW79lP8Q3o5AkHsxO' : 'SkcpefyfVnylOX0Q5lXtvn8fmot8C6cx';
    case 'staging':
    case 'integration':
      return url.host === 'stg.app.facet.com' || url.host === 'int.app.facet.com'
        ? 'rwCqYSQK2TDymsq7K9Eqvy6QenJWyvRr'
        : 'Z1A4RGTLMNmAH8CJDyhKrHSyCcdu2Ztq';
    case 'development':
      return null;
      // Uncomment to test instrumentation in Segment
      // return 'Z1A4RGTLMNmAH8CJDyhKrHSyCcdu2Ztq';
    default:
      return null;
  }
};

let segment;
const enablementFilter = {
  isDisabled: !getAPIKey(),
};

export const initializeSegment = () => {
  segment = AnalyticsBrowser.load({ writeKey: getAPIKey() });

  Dispatcher.registerIdentify(enablementFilter, ({ visitorSessionUUID }) => {
    if (!segment) return;
    if (visitorSessionUUID) segment.setAnonymousId(visitorSessionUUID);
  });

  const segmentEvents = Object.values(segmentTypes);
  Dispatcher.registerLogEvent(enablementFilter, ({ eventName, eventProperties }) => {
    if (!segment) return;
    if (!segmentEvents.find(e => e === eventName)) return;
    segment.track(eventName, eventProperties);
  });

  Dispatcher.registerLogPage(enablementFilter, ({ eventName, eventProperties }) => {
    if (!segment) return;
    if (eventName !== 'payment') return;
    segment.page(eventName, eventProperties);
  });
};


export const teardownSegment = () => {
  if (segment) {
    segment = null;
  }
};
